import { Behavior } from "../Behavior";
import { Particle } from "../Particle";
import type { IGrid } from "../types";
import { Empty } from "../particles/Empty";

/**
 * 燃烧殆尽行为
 * 当粒子温度超过阈值时，有概率变为 Empty
 */
export class BurnOut extends Behavior {
    threshold: number;
    probability: number;

    /**
     * @param threshold 温度阈值，超过此温度可能消失
     * @param probability 每一帧消失的概率 (0-1)
     */
    constructor(threshold: number, probability: number) {
        super();
        this.threshold = threshold;
        this.probability = probability;
    }

    update(particle: Particle, grid: IGrid, index: number): number | void {
        if (particle.temperature >= this.threshold) {
            if (Math.random() < this.probability) {
                // 变成 Empty，模拟燃烧殆尽
                grid.setIndex(index, new Empty());
                return -1; // 表示粒子已被销毁/替换
            }
        }
        return;
    }
}
